<template>
  <v-container class='Login'>
    <v-layout v-if='!loadingRegion' align-center justify-center row wrap h100 mt5>
      <v-flex class='container-login'>
        <v-flex class='login-box'>
          <img src='@/assets/img/logo-super-comics.png' v-if="isoCode === 'BR'" alt='logo' />
          <img src='@/assets/img/logo-super-comics-global.png' v-else alt='logo' />
        </v-flex>

        <transition name='fade' mode='out-in' tag='v-layout' class='row'>
          <v-flex xs12 key='btnSteps'>
            <v-layout lang column>
              <v-flex class='container-phone'>

                <header class='text-black'>
                  <h1 style='font-size: 30px'>
                    {{ handleMessageCode ? $t('title.accessPartnersPhone') : $t('title.accessPartnersPhone') }}</h1>
                  <h5 style='font-size: 16px; margin-top: 10px; font-weight: normal'>
                    {{ handleMessageCode ? $t('text.confirmPhone') : $t('text.accessAccountPhone')
                    }}</h5>
                </header>

                <div class='px-3 pt-3 text-black'>

                  <h5 v-if="!handleMessageCode"
                      style='font-size: 16px; margin: 20px 0; font-weight: normal; max-width: 438px'>
                    {{ $t('text.insertNumberPhone') }}</h5>

                  <p v-if="handleMessageCode"
                     style='font-size: 16px; margin-top: 10px; font-weight: normal; max-width: 438px'>
                    {{ $t('text.insertCode') }} <br />{{ `+${selectedCountry.areaCode} ${phoneNumber}`
                    }}
                  </p>

                  <v-form v-if="!handleMessageCode" class='form-container'>
                    <v-flex style="display: flex; flex-direction: row; width: 100%">
                      <v-menu
                        :close-on-content-click='true'
                        style='width: fit-content'
                        offset-y
                      >
                        <v-btn slot='activator' dark flat='flat' class='mr-2 px-0'>
                          <v-avatar :tile='false' :size='18' color='grey lighten-4 mr-2'>
                            <img :src='`https://cdn.supercomics.com.br/static/flags/${selectedCountry.isoCode}.png`'
                                 alt='Pais' />
                          </v-avatar>

                          <span style='color: black'>+{{ selectedCountry.areaCode }}</span>
                          <v-icon color='black' right class='ml-1'>keyboard_arrow_down</v-icon>
                        </v-btn>

                        <v-list
                          class='list-countries'>
                          <v-list-tile small v-for='(item, index) in countries' :key='index' @click='setRegion(item)'>

                            <v-avatar :tile='false' :size='22' color='grey lighten-4 mr-2'>
                              <img :src='`https://cdn.supercomics.com.br/static/flags/${item.isoCode}.png`'
                                   alt='Pais' />
                            </v-avatar>
                            <span style='color: black'>+{{ item.areaCode }}</span>
                          </v-list-tile>
                        </v-list>
                      </v-menu>

                      <v-text-field
                        v-model='phoneNumber'
                        v-mask="selectedCountry.maskPattern"
                        :placeholder="'Ex: (11) 99999-9999'"
                        required
                        outlined
                        autocomplete="tel"
                        autofocus
                      ></v-text-field>
                    </v-flex>

                    <span>{{ $t('text.messageAboutFee') }}</span>

                    <v-btn
                      type='submit'
                      class='mb-3 mt-3'
                      @click.prevent='sendNumber'
                      :disabled='phoneNumber.length < 15 || this.isLoading'
                      color='primary darken-4 white--text full mt-2 elevation-0'
                    >{{ this.isLoading ? $t('text.isLoading') : $t('text.send') }}
                    </v-btn>
                  </v-form>

                  <v-form v-else class='form-container'>
                    <v-text-field
                      v-model='messageCode'
                      v-mask="['######']"
                      :label="$t('text.digitCode')"
                      required
                      outlined
                      autocomplete='nope'
                      autofocus
                      style="width: 100%"
                    ></v-text-field>

                    <div>
                      <span v-if="timeExpiredCode > 0" class="mb-2"
                            style="font-size: 12px">{{ $t('text.expiredIn ') + ' ' + expireCode }}</span>

                      <v-btn v-else-if="!timeExpiredCode > 0" @click.prevent='sendNumber' dark flat='flat'
                             class='mr-2 text-black' v-else>
                        {{ $t('text.resend') }}
                      </v-btn>
                    </div>

                    <div style="width: 100%">
                      <v-btn
                        type='submit'
                        class='mb-3'
                        @click.prevent='sendCode'
                        :disabled='messageCode.length < 6 || isLoading'
                        color='primary darken-4 white--text full mt-2 elevation-0'
                      >{{ isLoading ? $t('text.isLoading') : $t('text.toEnter') }}
                      </v-btn>

                      <v-btn
                        type='submit'
                        class='mb-3'
                        @click.prevent='handleMessageCode = false'
                        :disabled='isLoading'
                        color='secondary darken-4 white--text full mt-2 elevation-0'
                      >{{ $t('text.cancel') }}
                      </v-btn>
                    </div>
                  </v-form>

                  <!--                  <div v-if="handleMessageCode" class='mb-2'>-->
                  <!--                    <p v-if="timeRemaining !== 0"-->
                  <!--                       style='font-size: 16px; margin-bottom: 15px; font-weight: normal;'>-->
                  <!--                      {{ $t('text.resendCode') }}-->

                  <!--                    </p>-->
                  <!--                    <v-progress-circular v-if='timeRemaining !== 0' color='secondary' :width='10' :size='75'-->
                  <!--                                         :value='progress'><p class='font-weight-bold' style='font-size: 30px'>-->
                  <!--                      {{ timeRemaining }}</p>-->
                  <!--                    </v-progress-circular>-->
                  <!--                    <v-btn @click.prevent='sendNumber' dark flat='flat' class='mr-2 text-black' v-else>-->
                  <!--                      {{ $t('text.resend') }}-->
                  <!--                    </v-btn>-->
                  <!--                  </div>-->

                </div>

              </v-flex>


            </v-layout>
          </v-flex>
        </transition>
      </v-flex>

      <dialog-default
        :show='dialog.show'
        :title='dialog.title'
        :message='dialog.message'
        :ok='dialog.ok'
        v-on:close='dialogClose'
      ></dialog-default>
    </v-layout>

    <v-layout
      v-if='loadingRegion'
      class='loading-login'>
      <v-progress-circular
        :size='70'
        :width='7'
        indeterminate color='primary'
        class='center-block'>
      </v-progress-circular>
    </v-layout>


  </v-container>

</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex';
import VueTheMask from 'vue-the-mask';
import DialogDefault from '@/components/dialog/Default';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import { analytics } from '@/main';

Vue.use(Vuex);
Vue.use(VueCookies);
Vue.use(VueTheMask);

export default {
  components: {
    'dialog-default': DialogDefault
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      dialog: {
        show: false,
        title: '',
        message: '',
        ok: () => {}
      },
      partnerData: this.$route.params,
      countries: [],
      phoneNumber: '',
      selectedCountry: null,
      regionId: this.$route.params.regionId,
      isoCode: this.$route.params.isoCode || 'BR',
      handleMessageCode: false,
      messageCode: '',
      timeExpiredCode: 300,
      timeRemaining: 59,
      token: null,
      isLoading: false,
      loadingRegion: false,

      rules: {
        required: v => !!v || this.$t('errors.isRequired')
      }
    };
  },
  computed: {
    progress() {
      if (this.timeRemaining > 0) {
        setTimeout(() => {
          this.timeRemaining--;
        }, 1000);
      }
      return (this.timeRemaining / 59) * 100;
    },
    expireCode() {
      if (this.timeExpiredCode > 0) {
        setTimeout(() => {
          this.timeExpiredCode--;
        }, 1000);
      }
      const minutes = Math.floor(this.timeExpiredCode / 60);
      let seconds = this.timeExpiredCode % 60;

      seconds = seconds < 10 ? '0' + seconds : seconds;

      return minutes + ':' + seconds;
    }
  },
  methods: {
    dialogClose() {
      this.dialog.show = false;
    },
    setRegion(item) {
      this.selectedCountry = item;
    },
    async getCountries() {
      this.loadingRegion = true;

      try {
        const isoCode = this.isoCode;
        const { data } = await axios.get(
          `api/phone-verify/regions?isoCode=${isoCode}`
        );

        this.countries = data;
        this.selectedCountry = data.filter(row => row.isoCode === isoCode)[0];
        const regionsIds = data.map(row => row.id);

        if (!this.regionId.includes(regionsIds)) {
          this.dialog = {
            show: true,
            title: 'Ops...',
            message: this.$t('text.countrySupport'),
            ok: () => {
              this.$router.push('/');
            }
          };
        }
      } catch (error) {
        this.dialog = {
          show: true,
          title: 'Ops...',
          message: error.response.data.message,
          ok: () => {
            this.$router.push('/');
          }
        };
      } finally {
        this.loadingRegion = false;
      }
    },
    async sendNumber() {
      try {
        this.isLoading = true;

        const regionId = this.selectedCountry.id || this.regionId;

        const { data } = await axios.post(`api/phone-verify/send-sms`, {
          phoneNumber: this.phoneNumber,
          regionId
        });

        this.messageCode = '';

        this.token = data.token;

        const expiresAt = new Date(data.expiresAt);

        const currentTime = new Date().getTime();
        const remainingTime = expiresAt.getTime() - currentTime;

        this.timeExpiredCode = Math.floor(remainingTime / 1000);
        this.timeRemaining = 59;
        this.handleMessageCode = true;
      } catch (error) {
        this.dialog = {
          show: true,
          title: 'Ops...',
          message: error.response.data.message,
          ok: () => {
            this.dialog.show = false;
            this.handleMessageCode = false;
          }
        };
      } finally {
        this.isLoading = false;
      }
    },
    async sendCode() {
      try {
        this.isLoading = true;

        if (!this.token) this.handleMessageCode = false;

        const { data } = await axios.post(`/api/phone-verify/code`, {
          token: this.token,
          code: this.messageCode
        });

        const { token } = data;

        if (token) {
          Vue.cookies.set('sctoken', token);

          if (sessionStorage.getItem('redirectPath')) {
            let redirect = sessionStorage.getItem('redirectPath');
            this.$router.push(redirect);
            sessionStorage.removeItem('redirectPath');
          } else {
            analytics.logEvent('login_partner', {
              id_user: this.$store.getters.profile.id,
              document: data.profile.document,
              name: data.profile.name,
              partner_name: this.partnerData.name
            });
            this.$router.push('/');
          }
        }
      } catch (error) {
        this.dialog = {
          show: true,
          title: 'Ops...',
          message: error.response
            ? error.response.data.response
            : 'Código de verificação inválido',
          ok: () => {
            this.dialog.show = false;
          }
        };
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.getCountries();
  }
};
</script>

<style lang='scss' scoped>
*,
*:before,
*:after {
  box-sizing: inherit;
  margin: auto;
}

.container-phone {
  text-align: center;
  overflow: auto;
  padding: 20px;
  margin-top: 40px;
  background-color: #ffffff;
  width: auto;
  min-width: 500px;

  @media (max-width: 500px) {
    width: 100%;
    min-width: fit-content;
  }
}

.form-container {
  width: 100%;
  margin-bottom: 10px;
  flex-direction: column;

  @media (min-width: 330px) {
    display: flex;
  }
}

.list-countries {
  width: fit-content;
  position: relative;
  top: 0;
}

.text-black {
  color: black;
}

.loading-login {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 720px) {
    margin-top: 200px;
  }
}
</style>
